import { z } from "zod"

export const aircraftFileRecordSchema = z.object({
    id: z.string(),
    org_id: z.string(),
    aircraft_id: z.string(),
    name: z.string().min(1).max(255),
    expires_at: z.coerce.string().nullable(),
    notes: z.string().max(2000).nullable(),
    file_name: z.string().max(500),
    created_at: z.coerce.string(),
    updated_at: z.coerce.string().nullable(),
    file_size_bytes: z.coerce.number().nullable(),
})

export const aircraftFileSchema = aircraftFileRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    aircraftId: r.aircraft_id,
    name: r.name,
    expiresAt: r.expires_at,
    notes: r.notes,
    fileName: r.file_name,
    fileSizeBytes: r.file_size_bytes,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
}))

export const creatableAircraftFileSchema = aircraftFileRecordSchema.omit({
    created_at: true,
    updated_at: true,
    org_id: true,
    aircraft_id: true,
})

export type AircraftFileRecord = z.infer<typeof aircraftFileRecordSchema>
export type AircraftFile = z.infer<typeof aircraftFileSchema>
export type CreatableAircraftFile = z.infer<typeof creatableAircraftFileSchema>
